import React, { useEffect, useState } from 'react';
import Spinner from '../../shared/Spinner';
import { useNavigate, useParams } from 'react-router-dom';
import { Clipboard } from 'react-bootstrap-icons';
import useApi from '../../hooks/UseApi';
import moment from 'moment';

const tryPretty = (str) => {
  if (!str) return null;
  try { return JSON.stringify(JSON.parse(str), null, 2); }
  catch { return str; }
};

const CodeBlock = ({ value, onCopy }) => {
  if (!value) return <span className="text-muted">—</span>;
  return (
    <div className="position-relative">
      <pre className="bg-light border rounded p-2 mb-0" style={{ fontSize: '0.8rem', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
        {tryPretty(value)}
      </pre>
      <a href="#!" title="Copiar" className="position-absolute top-0 end-0 m-1 text-secondary"
        onClick={(e) => { e.preventDefault(); onCopy(value); }}>
        <Clipboard size={14} />
      </a>
    </div>
  );
};

const LogView = () => {
  const [log, setLog]     = useState();
  const { get, updating } = useApi();
  const { id }            = useParams();
  const navigate          = useNavigate();

  useEffect(() => {
    get('v2/logs/' + id).then(r => setLog(r.data));
  }, [id]);

  const copy = (value) => navigator.clipboard.writeText(value);

  return (
    <div className="card">
      <div className="card-body">
        <div className="d-flex align-items-center mb-3">
          <button className="btn btn-sm btn-outline-secondary me-3" onClick={() => navigate('/logs')}>
            &larr; Volver
          </button>
          <h5 className="card-title mb-0">Detalle del Log</h5>
        </div>

        {(!log || updating) ? <Spinner /> : (
          <dl className="row">
            <dt className="col-sm-2">ID</dt>
            <dd className="col-sm-10 font-monospace text-muted" style={{ fontSize: '0.85rem' }}>{log.id}</dd>

            <dt className="col-sm-2">Fecha</dt>
            <dd className="col-sm-10">{moment(log.date).format('DD/MM/YYYY HH:mm:ss')}</dd>

            <dt className="col-sm-2">Máquina</dt>
            <dd className="col-sm-10">{log.machine}</dd>

            <dt className="col-sm-2">Recibido</dt>
            <dd className="col-sm-10"><CodeBlock value={log.content_received} onCopy={copy} /></dd>

            <dt className="col-sm-2">URL enviada</dt>
            <dd className="col-sm-10">
              {log.url_sent
                ? <span className="font-monospace" style={{ fontSize: '0.85rem', wordBreak: 'break-all' }}>{log.url_sent}</span>
                : <span className="text-muted">—</span>}
            </dd>

            <dt className="col-sm-2">Enviado</dt>
            <dd className="col-sm-10"><CodeBlock value={log.content_sent} onCopy={copy} /></dd>
          </dl>
        )}
      </div>
    </div>
  );
};

export default LogView;
